import styled from 'styled-components';
import COLORS from '../../../constants/COLORS';
import COLORS_MARKETPLACE from '../../../constants/COLORS_MARKETPLACE';
import filtersIcon from '../../../images/filters.svg';
import mixins from '../../../styles/mixins';

export default {
  SideBar: styled.div`
    position: relative;
    margin-top: -130px;
    width: 100%;
    background-color: ${COLORS_MARKETPLACE.GREY};
    overflow-y: auto;
    flex-shrink: 0;
    z-index: 10;
    order: 2;

    @media (min-width: 768px) {
      display: flex;
      flex-direction: column;
      width: 38%;
      max-width: 486px;
      min-width: 320px;
      height: 100%;
      margin-top: 0;
      order: 1;
    }
  `,

  Header: styled.div`
    position: sticky;
    top: -1px;
    left: 0;
    right: 0;
    padding: 20px;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    background-color: ${COLORS.WHITE};
    z-index: 1;

    @media (min-width: 768px) {
      border-radius: 0;
    }
  `,

  FlexHelper: styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
  `,
  Name: styled.div`
    ${mixins.h3}

    margin-bottom: 4px;

    & > span {
      &:not(:first-child) {
        position: relative;
        padding-left: 11px;

        &::after {
          content: '';
          position: absolute;
          top: 50%;
          left: 4px;
          width: 3px;
          height: 3px;

          background-color: ${COLORS_MARKETPLACE.BLACK};

          border-radius: 50%;
          transform: translateY(-50%);
        }
      }
    }
  `,
  FiltersOpenBtn: styled.button`
    ${mixins.btnReset}

    width: 36px;
    height: 36px;

    border: 1px solid transparent;
    border-radius: 8px;

    background-color: ${COLORS_MARKETPLACE.GREY};

    background-image: url(${filtersIcon});
    background-position: center;
    background-repeat: no-repeat;

    transition: 0.1s ease-in;

    &:hover {
      border-color: rgba(21, 16, 53, 0.4);
    }
  `,
  TypeFilter: styled.ul`
    ${mixins.listReset}
    ${mixins.hideScrollBar}

    display: flex;
    align-items: center;

    padding-top: 24px;

    overflow-x: auto;

    & > li {
      flex-shrink: 0;
      &:not(:last-child) {
        margin-right: 4px;
      }
    }
  `,
  TypeFilterBtn: styled.button<{ isActive?: boolean }>`
    ${mixins.btnReset}

    display: block;

    padding: 8px 12px;

    border: 1px solid ${COLORS.WHITE_F0};
    border-radius: 20px;

    font-size: 12px;
    line-height: 1.2;
    font-weight: ${({ isActive }) => (isActive ? '700' : '500')};

    background-color: ${({ isActive }) => (isActive ? COLORS_MARKETPLACE.GREY : 'transparent')};

    transition: 0.1s ease-in;

    &:hover,
    &:focus-visible {
      border-color: rgba(21, 16, 53, 0.4);
    }
  `,
  Prices: styled.div`
    opacity: 0.4;
  `,

  Loading: styled.div`
    height: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    font-size: 16px;
  `,

  Spinner: styled.div`
    position: relative;
    width: 50px;
    height: 50px;
    margin-top: 16px;
  `,

  Empty: styled.div`
    display: flex;
    height: 100%;
    align-items: center;
    padding: 0 18px;
    font-size: 16px;
    text-wrap: balance;
  `,

  EventInfo: styled.div<{ isEmpty: boolean }>`
    position: relative;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    height: ${({ isEmpty }) => (!isEmpty ? '20px' : 'auto')};
    background-color: ${({ isEmpty }) => (isEmpty ? COLORS.GREY_D9 : 'transparent')};
    border-radius: 4px;
    color: ${({ isEmpty }) => (isEmpty ? 'transparent' : COLORS.GREY_49)};

    &::after {
      content: ${({ isEmpty }) => (isEmpty ? "''" : 'none')};
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(
        90deg,
        rgba(0, 0, 0, 0) 25%,
        rgba(0, 0, 0, 0.2) 50%,
        rgba(0, 0, 0, 0) 75%
      );
      animation: shimmer 1.5s infinite;
    }

    @keyframes shimmer {
      0% {
        transform: translateX(-100%);
      }
      100% {
        transform: translateX(100%);
      }
    }
  `,

  EventTitle: styled.div`
    font-weight: 600;
    width: 100%;
    white-space: nowrap;
  `,

  DateInfo: styled.div`
    font-weight: 600;
    width: 100%;
    white-space: nowrap;
  `,
};
